import React from 'react';
import {
    Typography,
    Box,
    Avatar,
    Chip,
    Tooltip,
} from "@mui/material";
import { _date, formatMoney } from "../../../utils/helpers";

function getCourseName(row) {
    return row.name_en || row.name_ru || row.name_hy || '—';
}

export const CourseColumns = () => [
    {
        id: "name",
        label: "Name",
        render: (value, row) => {
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 2 }} >
                    {row.thumbnail ? (
                        <Avatar
                            variant="rounded"                            
                            src={row.thumbnail}
                            alt={getCourseName(row)}
                            sx={{ width: 80, height: 80, boxShadow: 3 }}
                        />
                    ) : (
                        <Avatar variant="rounded" sx={{ width: 80, height: 80 }} />                            
                    )}
                    <Typography variant="body2" sx={{ fontWeight: 500, textAlign: 'center' }}>
                        {getCourseName(row)}
                    </Typography>
                </Box>
            );
        }
    },
    {
        id: "category",
        label: "Category",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                {row.category ? (row.category.title_en || row.category.title_ru || row.category.title_hy || row.category.id) : '—'}
            </Typography>
        )
    },
    {
        id: "price",
        label: "Price",
        render: (value, row) => (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, flexWrap: 'wrap' }}>
                {row.price != null ? (
                    <Tooltip
                        title={`Original price: ${formatMoney(row.original_price)}`}
                        arrow
                    >
                        <Chip
                            label={formatMoney(row.price)}
                            size="small"
                            color="success"
                            variant="outlined"
                        />
                    </Tooltip>
                ) : (
                    <Chip label="—" size="small" variant="outlined" />
                )}
            </Box>
        )
    },
    {
        id: "discount",
        label: "Discount",
        render: (value, row) => (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Chip
                    label={`${row.discount ?? 0}%`}
                    size="small"
                    color={row.discount > 0 ? "error" : "default"}
                    variant={row.discount > 0 ? "filled" : "outlined"}
                />
            </Box>
        )
    },
    {
        id: "total_lessons",
        label: "Lessons",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                {row.total_lessons != null && row.total_lessons !== '' ? row.total_lessons : '—'}
            </Typography>
        )
    },
    {
        id: "duration",
        label: "Duration (days)",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                {row.duration != null && row.duration !== '' ? row.duration : '—'}
            </Typography>
        )
    },
    {
        id: "views",
        label: "Views",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                {row.views ?? 0}
            </Typography>
        )
    },
    {
        id: "sold",
        label: "Sold",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                {row.sold ?? 0}
            </Typography>
        )
    },
    {
        id: "created_at",
        label: "Created",
        render: (value, row) => (
            <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
                {_date(value, { relative: true })}
            </Typography>
        )
    },
];
